module.exports = __webpack_public_path__ + "static/the-dance-of-anger-b87135403ab9d152bbeeaad3a838c598.jpg";